import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#041635", // Dark Navy Blue
    },
    secondary: {
      main: "#00BFA5", // Teal (or replace with '#FFC107' for Gold)
    },
  },
});

export default theme;
